/* eslint-disable no-restricted-syntax */

import Immutable from 'immutable';
import {
  SET_LTI_PROVIDERS,
  SET_LTI_PROVIDER,
  DELETE_LTI_PROVIDER,
} from './actions';

const initialState = Immutable.fromJS({
  providers: {}, // providers mapped by id
});

/**
 * @param {object} state
 * @param {object} action
 * @returns {object}
 */
export function LTI(state = initialState, action = {}) {
  switch (action.type) {
    case DELETE_LTI_PROVIDER: {
      const ltiProvider = Immutable.fromJS(action.result);
      return state.deleteIn(['providers', ltiProvider.get('_id')]);
    }
    case SET_LTI_PROVIDERS: {
      let newState = state;
      for (const ltiProvider of Immutable.fromJS(
        action.ltiProviders
      ).values()) {
        newState = newState.setIn(
          ['providers', ltiProvider.get('_id')],
          ltiProvider
        );
      }
      return newState;
    }
    case SET_LTI_PROVIDER: {
      const ltiProvider = Immutable.fromJS(action.result);
      return state.setIn(['providers', ltiProvider.get('_id')], ltiProvider);
    }
    default: {
      return state;
    }
  }
}
